import Link from 'next/link'
import { memo } from 'react'

import { CatalogItem } from '@/entities/catalog/types'

import { BASE_URL } from '@/shared/lib/const/env'
import { PRODUCT_IMAGE_PLACEHOLDER } from '@/shared/lib/utils/constants/const'
import { Image } from '@/shared/ui/Image'

import styles from './SquareCatBlock.module.scss'

export const SquareCatItem = memo(({ NAME, PREVIEW_PICTURE, LINK, withBaseUrl }: CatalogItem): JSX.Element => {
	const image = PREVIEW_PICTURE
		? withBaseUrl
			? BASE_URL + PREVIEW_PICTURE
			: PREVIEW_PICTURE
		: PRODUCT_IMAGE_PLACEHOLDER

	return (
		<li className={styles.item}>
			<Link
				prefetch={false}
				href={`${LINK}`}
				className={[`gtm-info-page-categories-block`, styles.link].filter(Boolean).join(' ')}>
				<div className={styles.imageWrap}>
					<Image alt={NAME} style={{ objectFit: 'cover' }} src={image} width={78} height={78} />
				</div>
				<h5 className={styles.itemTitle}>{NAME}</h5>
			</Link>
		</li>
	)
})
